module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/basis_grotesque_bold-898df8f54830347fc679860fa8dff667.woff";